var $ = require('jquery');
var storyListing = $('.story-listing');

import {gsap} from 'gsap';

if ( storyListing.length ) {
    var filterResetButton = $('.story-listing__filter-reset-button');
    if ( filterResetButton.length ) {
        filterResetButton.on('click', function() {
            FWP.reset();
            filterResetButton.addClass('checked');
        })
    }
    
    $(document).on('facetwp-loaded', function() {
        console.log(FWP);
        var filtersArray = FWP.facets.stories_filter;
        filtersArray.length > 0 ? filterResetButton.removeClass('checked') : filterResetButton.addClass('checked');


        var storyCards = storyListing.find('.story-card').not('.visible');
        
        gsap.to(storyCards, {
            opacity: 1,
            y: 0,
            scrollTrigger: {
                trigger: storyListing,
                start: 'top 80%'
            },
            stagger: {
                each: 0.2,
                onComplete: function() {
                    $(this.targets()[0]).addClass('visible');
                }
            }, 
            duration: 0.7,
        })
    })
}